import axios from "axios";
import * as actionTyoes from './type';

export const handleRequestGetAllLookup = (authToken, currentClientId) => async(dispatch) => {

    try {

        const headerReq = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        }

        const url = currentClientId ? `${process.env.REACT_APP_LOOKUP_URL}lookup?clientId=${currentClientId}` : `${process.env.REACT_APP_LOOKUP_URL}lookup`

        const {data} = await axios.get(url, headerReq);

        dispatch({
            type: actionTyoes?.RECEIVED_GET_ALL_LOOKUP_DATA,
            payload: data
        })

    } catch(error) {

        console.log("error llokup", error);
    }
}


export const handleRequestGetLookup = (authToken) => async(dispatch) => {
        
    try {

        const headerReq = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        }

        const url = `${process.env.REACT_APP_LOOKUP_URL}lookup`;

        const {data} = await axios.get(url, headerReq);

        dispatch({
            type: actionTyoes?.RECEIVED_ALL_LOOKUP_DATA,
            payload: data
        })

    } catch(error) {

        console.log("error llokup", error);
    }

}



export const handleRequestGetAllSystemLookup = () => async(dispatch) => {

    try {

    } catch(error) {

    }
}



export const handleRequestCreateLookup = () => async(dispatch) => {

    try {

    } catch(error) {

    }
}


export const handleRequestDeleteLookup = () => async(dispatch) => {

    try {

    } catch(error) {

    }
}


export const handleRequestUpdateLookup = () => async(dispatch) => {

    try {

    } catch(error) {

    }
}


